<template>    
    <div class="my-1">
        <b-card>
            <p class="card-text">
                <b>{{ hotel.name }}</b> <small>{{ hotel.zon }}</small>
            </p> 
            <b-table striped hover sticky-header="400px" head-variant="light"
                :items="precios.items" :fields="precios.fields"
                selectable select-mode="single" @row-selected="selecciona" @row-dblclicked="selecciona"
                class="table-responsive-md bg-white" responsive="xs">

               <!--  <template slot="cell(sal)" slot-scope="{item: { sal }}">
                    <small>{{ sal }}</small>                        
                </template> -->            
                
                <!-- <template #cell(action)="data">
                    <b-btn size="lg" variant="light" class="p-0" v-if="data.item.lib<=1">
                        <b-icon variant="danger" icon="x-square"></b-icon>                        
                    </b-btn>
                    <b-btn size="md" variant="success" class="p-1" v-else @click="selecciona(data)">
                        <b-icon icon="cart3"></b-icon>
                        <b-badge variant="success">{{data.item.lib}}</b-badge>                        
                    </b-btn>                        
                </template> -->

            </b-table> 
            <!-- <p><small>Periodos </small> <b> {{turnos.items.length}} </b></p> -->
            <p v-html="selected.obs"/>
        </b-card>                    
        <div class="row mx-1 pl-4 mt-1 bg- text-faded">
            <div class="col-8">Periodos <b>{{precios.items.length}}</b></div>
            <div class="col-4 pr-5 mt-1">
                <p v-html="selected.tarifa"/>
                <!-- <b-icon variant="success" icon="cart3"></b-icon> Reservar
                <b-icon variant="danger" icon="x-square" class="ml-4"></b-icon> Sin disponibilidad -->
            </div>    
        </div>
    </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    name: 'hotel-turnos',
    
    data() {
        return {
            plan: 1,
            
            precios: {
                items: {},
                fields: [
                    // {key:'sal',label:'Transporte'},
                    {key:'per',label:'Periodo'},
                    {key:'tph',label:'TipoHab'},          
                    {key:'reg',label:'Reg.'},          
                    {key:'ven',label:'Venta'},          
                    {key:'apo',label:'Aporta'},          
                    {key:'sub',label:'Subven'},          
                    {key:'sind',label:'SupInd'},          
                    /* {key:'dias',label:'Dias'},
                    {key:'pre',label:'Precio'},           */
                    {key:'action', label:''}
                ],
            },
            selected: {},

        }
    },
    
    mounted() {
      this.leemos();
    },

    computed: {
        ...mapState(['auth']),

        hotel() {
            return this.$store.state.hotel;
        },    

    },
    methods: {
        ...mapMutations(['loading','alerta','modal']),
        ...mapActions(['exec']), 

        seleccion(item) {       

            this.$store.state.hoteles.turno=item.item;
            // abrimos reservar sino ...
            if (this.$route.name!='reservar')
                this.$router.push('/reservar');
            //console.log("*selecciona",item.item.id,this.$store.state.hoteles.turno);
            this.close();
        },

        close() {
            this.$bvModal.hide('modal_hotelPrecios');
        },

        async leemos() {
            this.loading();

            var args={ token: this.auth.token, plan: this.plan }
            let r=await this.exec({api:'hotel_turnos', arg: args });

            this.loading(false);

            if (r.error) {
                //mensaje error modal ... mostrar r.datos
                //this.modal({tit:"RESERVAS", msg:r.datos});
                r.datos=[];
            }                              
            //guardamos datos
            this.precios.items=Object.values(r.datos[0]);                                                    

            this.selecciona(this.precios.items);
        },

        selecciona(item) {
            this.selected=item[0];
        }
    }
}
</script>
